import { useState } from "react";
import { Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import { ImageIcon } from "../../common/ImageIcon";
import { scrollToSection } from "../../common/utils/scrollToSection";
import { CONTACT_FORM_URL } from "../../common/utils/constants";
import {
  HeaderSection,
  HeaderInner,
  LogoContainer,
  Burger,
  ContactNavItem,
  DesktopCta,
  DesktopNav,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: any) => {
  const [visible, setVisibility] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const isHome = pathname === "/" || pathname === "/home";

  const showDrawer = () => {
    setVisibility(!visible);
  };

  const onClose = () => {
    setVisibility(!visible);
  };

  // 首页锚点在其他页面不存在，需要先回到首页再滚动。
  const goToSection = (id: string) => {
    setVisibility(false);

    if (isHome) {
      scrollToSection(id);
      return;
    }

    history.push({ pathname: "/", hash: id });
  };

  const goToPage = (path: string) => {
    setVisibility(false);
    history.push(path);
  };

  const openContactForm = () => {
    window.open(CONTACT_FORM_URL, "_blank", "noopener,noreferrer");
    setVisibility(false);
  };

  const NavItems = () => (
    <>
      <CustomNavLinkSmall onClick={() => goToSection("solution")}>
        <Span>{t("解决方案")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => goToPage("/solutions/ai-agent")}>
        <Span>{t("AI 智能体")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => goToPage("/solutions/elv")}>
        <Span>{t("综合弱电")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => goToSection("customer")}>
        <Span>{t("客户案例")}</Span>
      </CustomNavLinkSmall>
      <CustomNavLinkSmall onClick={() => goToSection("about-us")}>
        <Span>{t("关于我们")}</Span>
      </CustomNavLinkSmall>
    </>
  );

  const ContactCta = () => (
    <ContactNavItem onClick={openContactForm}>
      <Span>
        <Button>{t("联系我们")}</Button>
      </Span>
    </ContactNavItem>
  );

  return (
    <HeaderSection>
      <Container>
        <HeaderInner>
          <LogoContainer to="/" aria-label="homepage">
            <ImageIcon src="logo-ffan.png" width="90px" height="40px" />
          </LogoContainer>
          <DesktopNav>
            <NavItems />
          </DesktopNav>
          <DesktopCta>
            <ContactCta />
          </DesktopCta>
          <Burger onClick={showDrawer}>
            <Outline />
          </Burger>
        </HeaderInner>
        <Drawer closable={false} visible={visible} onClose={onClose}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={onClose}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <NavItems />
          <ContactCta />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
